export default __webpack_public_path__ + "static/coperta-cum-obtii-card-penny-2bece4b99bca3c70426018b3bc39b6e4.jpg";